import React from 'react';

export const UploadFile: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.9442 52.9044H21.1074C15.885 52.9044 11.6226 48.6548 11.6226 43.4196V21.5956C11.6226 16.3732 15.8722 12.1108 21.1074 12.1108H42.9442C48.1666 12.1108 52.429 16.3604 52.429 21.5956V43.4324C52.429 48.6548 48.1794 52.9044 42.9442 52.9044Z"
        fill="#EFF2F4"
      />
      <path
        d="M17.9329 18.1011H45.8113C46.4513 18.1011 46.9761 18.6259 46.9761 19.2659C46.9761 19.9059 46.4513 20.4307 45.8113 20.4307H17.9329C17.2929 20.4307 16.7681 19.9059 16.7681 19.2659C16.7809 18.6259 17.2929 18.1011 17.9329 18.1011Z"
        fill="#ED9FAC"
      />
      <path
        d="M17.9329 24.5654H45.8113C46.4513 24.5654 46.9761 25.0902 46.9761 25.7302C46.9761 26.3702 46.4513 26.895 45.8113 26.895H17.9329C17.2929 26.895 16.7681 26.3702 16.7681 25.7302C16.7809 25.0902 17.2929 24.5654 17.9329 24.5654Z"
        fill="#ED9FAC"
      />
      <path
        d="M17.9329 31.0293H41.3441C41.9841 31.0293 42.5089 31.5541 42.5089 32.1941C42.5089 32.8341 41.9841 33.3589 41.3441 33.3589H17.9329C17.2929 33.3589 16.7681 32.8341 16.7681 32.1941C16.7809 31.5541 17.2929 31.0293 17.9329 31.0293Z"
        fill="#ED9FAC"
      />
      <path
        d="M17.9329 37.4932H44.2113C44.8513 37.4932 45.3761 38.018 45.3761 38.658C45.3761 39.298 44.8513 39.8228 44.2113 39.8228H17.9329C17.2929 39.8228 16.7681 39.298 16.7681 38.658C16.7809 38.018 17.2929 37.4932 17.9329 37.4932Z"
        fill="#ED9FAC"
      />
      <path
        d="M17.9329 43.957H35.7889C36.4289 43.957 36.9537 44.4818 36.9537 45.1218C36.9537 45.7618 36.4289 46.2866 35.7889 46.2866H17.9329C17.2929 46.2866 16.7681 45.7618 16.7681 45.1218C16.7809 44.4818 17.2929 43.957 17.9329 43.957Z"
        fill="#ED9FAC"
      />
    </svg>
  );
};
